import { memo } from 'react'

import circle from '@/assets/icons/circle.png'
import conveyorBeltBg from '@/assets/icons/conveyor-belt.png'
import plmingDisabled from '@/assets/icons/disabled/plming-disabled.png'
import light from '@/assets/icons/light.png'
import plming from '@/assets/icons/plming.png'
import { CONVEYOR_ITEMS } from '@/pages/gacha/steps/constants'

import {
  BeltBackground,
  ConveyorContainer,
  ConveyorTrack,
  ConveyorWrapper,
  DisabledPlmingImage,
  HeroMainImageBox,
  LightIcon,
  PlmingImage,
  SparkleIcon,
} from './styles'

interface ConveyorImageBoxProps {
  isDisabled?: boolean
}

export const ConveyorImageBox = memo(({ isDisabled = false }: ConveyorImageBoxProps) => {
  const renderSet = (prefix: string) =>
    CONVEYOR_ITEMS.map((item, i) => (
      <img key={`${prefix}-${i}`} src={item.src} alt={item.alt} loading='eager' decoding='async' />
    ))

  return (
    <ConveyorContainer>
      <HeroMainImageBox>
        {isDisabled ? (
          <DisabledPlmingImage src={plmingDisabled} alt='' loading='eager' decoding='async' />
        ) : (
          <>
            <LightIcon src={light} alt='' left={79} top={19} size={48} rotate={-8} delay={0} />
            <LightIcon src={light} alt='' left={258} top={3} size={36} rotate={-4} delay={0.8} />
            <LightIcon src={light} alt='' left={0} top={-3} size={32} rotate={-30} delay={1.6} />
            <SparkleIcon src={circle} alt='' left={284} top={66} delay={0.4} />
            <SparkleIcon src={circle} alt='' left={35} top={57} delay={1.2} />
            <SparkleIcon src={circle} alt='' left={323} top={16} delay={2} />
            <PlmingImage src={plming} alt='' loading='eager' decoding='async' width={116} height={114} />
          </>
        )}
      </HeroMainImageBox>

      {/* 컨베이어 트랙 (3세트 = 버퍼 1세트 포함, 모바일 WebView 오프스크린 렌더링 대응) */}
      <ConveyorWrapper>
        <ConveyorTrack data-testid='conveyor-track' isDisabled={isDisabled}>
          {renderSet('a')}
          {renderSet('b')}
          {renderSet('c')}
        </ConveyorTrack>
      </ConveyorWrapper>

      {/* 벨트 배경 이미지 */}
      <BeltBackground src={conveyorBeltBg} alt='' loading='eager' decoding='async' />
    </ConveyorContainer>
  )
})
